<div class="example-button-container">
    <button mat-fab style="background-color: #383A41;color: white;" aria-label="Example icon button with a delete icon" (click)="method()" [disabled]="disabled">
      <mat-icon style="font-size: x-large;color:white">{{icon}}</mat-icon>
    </button>
  </div>